// API Base URL Configuration
// export const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL_PROD || "https://api.example.com";
// REACT_APP_API_BASE_URL_DEV="http://127.0.0.1:8000/"

// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_DEV;

// export const API_BASE_URL = "http://127.0.0.1:8000/";
export const API_BASE_URL = "http://45.194.47.66:8450/";
// export const API_BASE_URL = "https://fznj4r32-8000.inc1.devtunnels.ms/";

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: "auth/admin_login",
  VERFIY_ADMIN_OTP: "auth/verify_admin_otp",
  LOGOUT: "/auth/logout",
  RESEND_OTP: "auth/resend_otp",

  RESET_PASSWORD: (token) => `auth/reset_password/${token}/`,

  FORGOT_PASSWORD: "auth/forgot_password",

  CHANGE_PASSWORD: "auth/change_password",
  UPDATE_PROFILE: "auth/profile_update",

  // Profile
  PROFILE: "auth/profile",

  //upload media
  UPLOAD_MEDIA: "auth/upload_media",

  // Clubs
  CLUBS_LIST: "club/clubs_list",
  CLUBS_CREATE: "club/clubs_create",
  CLUBS_UPDATE: "club/clubs",
  CLUBS_REORDER: "club/clubs_reorder",
  CLUBS_LIST_WITHOUT_PAGINATE: "club/club_list_without_pagination",

  // Attack & Defence
  ATTACK_LIST: "attack/attack_defence_list_create",
  ATTACK_UPDATE: "attack/attack_defence_by_id",
  ATTACK_REORDER: "attack/attack_defence_reorder",

  // Training
  TRAINING_LIST: "training/training_component_list_create",
  TRAINING_UPDATE: "training/training_component_by_id",
  TRAINING_REORDER: "training/training_components_reorder",

  //Theme
  THEMES_LIST: "theme/theme_list_create",
  THEMES_UPDATE: "theme/theme_by_id",
  THEMES_LIST_WITHOUT_PAGINATE: "theme/theme_without_pagination",

  //Theme manager

  THEMES_MANAGER_LIST: "theme/theme_manager_list_create",
  THEMES_MANAGER_UPDATE: "theme/theme_manager_by_id",
  THEMES_MANAGER_LIST_WITHOUT_PAGINATE:
    "theme/theme_manager_without_pagination",

  // users
  USERS_LIST: "user/users_list_create",
  USERS_UPDATE: "user/users_by_id",

  // Price Subscription
  PRICE_SUBSCRIPTION_LIST: "subscriptionprice/subscription_package_list_create",
  PRICE_SUBSCRIPTION_UPDATE: "subscriptionprice/subscription_package_by_id",

  // transactions
  SUBSCRIPTION_TRANSACTIONS_LIST:
    "subscriptionprice/subscription_transactions_list_create",
  SUBSCRIPTION_TRANSACTIONS_UPDATE:
    "subscriptionprice/subscription_transactions_by_id",

  //content
  CONTENT_GET_ALL: "content/get_all_contents",
  CONTENT_GET_BY_ID: "content/get_content_by_id",
  CONTENT_UPDATE: "content/update_content",

  //email template
  EMAIL_TEMPLATE_LIST: "email/get_all_email",
  EMAIL_TEMPLATE_UPDATE: "email/update_email",
  EMAIL_TEMPLATE_BY_ID: "email/get_email_by_id",

  //exercise
  EXERCISE_LIST: "exercise/exercises_list_create",
  EXERCISE_UPDATE: "exercise/exercises_by_id",
  EXERCISE_MOST_LIKED: "exercise/exercise_most_liked",

  //didactics
  DIDACTICS_LIST: "didactics/didactics_list",
  DIDACTICS_CREATE: "didactics/didactics_create",
  DIDACTICS_DETAIL_BY_ID: "didactics/didactics_by_id",
  DIDACTICS_UPDATE: "didactics/didactics_update",
  DIDACTICS_STATUS_CHANGE: "didactics/didactics_status",
  DIDACTICS_DELETE: "didactics/didactics_delete",

  //notifications
  NOTIFICATION_LIST: "notification/notification_list_create",
  NOTIFICATION_UPDATE: "notification/notification_by_id",
  NOTIFICATION_DETAIL_BY_ID: "notification/notification_by_id",

  //dashboard data
  DASHBOARD_DATA: "user/dashboard_data",
  TRAINING_COMPONENT_DASHBOARD: "training/training_component_dashboard",

  //user sessions
  USER_SESSIONS: "user/user_sessions_admin",
  USER_SESSIONS_LOGOUT: "user/user_sessions_logout",

  //tip sessions
  TIP_SESSIONS: "tips_video_analytics/create_tip",
  TIP_SESSIONS_LIST: "tips_video_analytics/tips_list_admin",
  TIP_SESSIONS_DETAIL_BY_ID: "tips_video_analytics/tip_detail",

  //club migrate
  CLUB_MIGRATE_LIST: "club/club_migrate_list",
  CLUB_MIGRATE_CREATE: "club/club_migrate_create",
  CLUB_MIGRATE_DETAIL: "club/club_migrate_detail",
  CLUB_MIGRATE_SEND_MESSAGE: "club/club_migrate_send_message",

  public_content: "api/v1/public/content",
};
